import CurrencyFormatter from "components/CurrencyFormatter";
import { BaseProp } from "entities/BaseProp";
import { RebateItems, SpecificationDetail } from "entities/ProductDetailsDTO";
import React, { FC } from "react";

const NotACurrencyArr = ["BC"];

interface RebateInfoProps extends BaseProp {
  productRebateList: RebateItems[];
}

const RebateInfo: FC<RebateInfoProps> = ({
  className = "",
  productRebateList,
}) => {
  const priceDiscountIcon = () => {
    return (
      <div>
        <svg
          stroke="currentColor"
          fill="none"
          stroke-width="2"
          viewBox="0 0 24 24"
          stroke-linecap="round"
          stroke-linejoin="round"
          height="25"
          width="25"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 15l6 -6"></path>
          <circle cx="9.5" cy="9.5" r=".5" fill="currentColor"></circle>
          <circle cx="14.5" cy="14.5" r=".5" fill="currentColor"></circle>
          <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"></path>
        </svg>
      </div>
    );
  };

  return (
    <div className="nc-RebateInfo bg-lavender-mist p-4 rounded-2xl flex items-start space-x-3">
      {priceDiscountIcon()}
      <div className="">
        <p className="text-gray-700">
          This product qualifies for{" "}
          <span className="font-semibold">rebates</span> that vary by province. Visit program operator website for details.
        </p>
        <div className="mt-2 grid grid-cols-2 sm:grid-cols-4 gap-x-3 gap-y-1 text-sm font-medium">
          {productRebateList.map((item) => (
            <span key={item.heading} className="text-gray-900">
              <span className="font-bold">{item.heading}:</span>{" "}
              {!NotACurrencyArr.includes(item.heading) ? (
                <CurrencyFormatter value={item.value} />
              ) : (
                item.value
              )}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RebateInfo;
